import { useVehicleContext } from '../../context/vehicle/context';

type UseRetrieveVehiclesAvatarResponseProps = {
  data: Record<string, string | undefined>;
};

// Hooks act as 'Adapter' layer.
export const useRetrieveVehiclesAvatar = (): UseRetrieveVehiclesAvatarResponseProps => {
  const { vehicleState } = useVehicleContext();
  return {
    data: vehicleState.vehiclesAvatarMap,
  };
};
